
import { API, API_GET_ID } from '../../Config'

export const GetSingleProduct= (id) => {
  return (
    API_GET_ID(API.singleproduct,id)
  )
}